<main class="check">
  <header [attr.id]="data.title">
    <h3 [class.error]="!data.isPassed">
      {{ data.title }}
    </h3>
  </header>
  <section
    class="check-cases"
    [class.border]="data.fireExtinguishingPumps.isApplicable"
    [attr.id]="data.fireExtinguishingPumps.title"
  >
    <mat-slide-toggle
      [color]="data.fireExtinguishingPumps.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="data.fireExtinguishingPumps.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span [class.error]="data.isApplicable && !data.isPassed">{{
        data.fireExtinguishingPumps.title
      }}</span>
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="
        data.fireExtinguishingPumps.isApplicable &&
        !data.fireExtinguishingPumps.isPassed
      "
      *ngIf="readonly || printPreview"
      >{{ data.fireExtinguishingPumps.title }}
    </span>
    <div
      class="cases"
      *ngIf="data.fireExtinguishingPumps.isApplicable; else notApplicable"
    >
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.fireExtinguishingPumps.shutdownPumpType"
        [fieldSection]="data.fireExtinguishingPumps.title"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.fireExtinguishingPumps.nominalPumpCapacityPressure"
        [fieldSection]="data.fireExtinguishingPumps.title"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.fireExtinguishingPumps.pumpDesignAccordingSpec"
        [fieldSection]="data.fireExtinguishingPumps.title"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.fireExtinguishingPumps.emergencyGeneratorSwitching"
        [fieldSection]="data.fireExtinguishingPumps.title"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.fireExtinguishingPumps.jockeyPumpSpeedPressure"
        [fieldSection]="data.fireExtinguishingPumps.title"
      ></authority-labs-check-case>
    </div>
  </section>
  <section
    class="check-cases"
    [class.border]="data.fireExtinguishingReservoir.isApplicable"
    [attr.id]="data.fireExtinguishingReservoir.title"
  >
    <mat-slide-toggle
      [color]="data.fireExtinguishingReservoir.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="data.fireExtinguishingReservoir.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span [class.error]="data.isApplicable && !data.isPassed">{{
        data.fireExtinguishingReservoir.title
      }}</span>
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="
        data.fireExtinguishingReservoir.isApplicable &&
        !data.fireExtinguishingReservoir.isPassed
      "
      *ngIf="readonly || printPreview"
      >{{ data.fireExtinguishingReservoir.title }}
    </span>
    <div
      class="cases"
      *ngIf="data.fireExtinguishingReservoir.isApplicable; else notApplicable"
    >
      <authority-labs-check-water-characteristics-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.fireExtinguishingReservoir.reservoirVolume"
        [fieldSection]="data.fireExtinguishingReservoir.title"
        [characteristics]="poolingVolumeCharacteristics"
      ></authority-labs-check-water-characteristics-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.fireExtinguishingReservoir.reservoirMaterialType"
        [fieldSection]="data.fireExtinguishingReservoir.title"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.fireExtinguishingReservoir.vortexPlateDesign"
        [fieldSection]="data.fireExtinguishingReservoir.title"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.fireExtinguishingReservoir.ballcockDesign"
        [fieldSection]="data.fireExtinguishingReservoir.title"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.fireExtinguishingReservoir.overflowPipeDesign"
        [fieldSection]="data.fireExtinguishingReservoir.title"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.fireExtinguishingReservoir.drainingDesign"
        [fieldSection]="data.fireExtinguishingReservoir.title"
      ></authority-labs-check-case>
    </div>
  </section>
</main>

<ng-template #notApplicable>
  <mat-radio-group disabled="true" class="print-preview" *ngIf="printPreview">
    <mat-radio-button checked="false">מתאים</mat-radio-button>
    <mat-radio-button checked="false">לא מתאים</mat-radio-button>
    <mat-radio-button value="true" checked="true">לא ישים</mat-radio-button>
  </mat-radio-group>
</ng-template>
